/** Soraka AbilitySpec seed kit (wiki-aligned numeric batch 1). */
export const SORAKA_ABILITY_DEFS = [
  {
    id: 'soraka_q',
    champKey: 'soraka',
    slot: 'Q',
    name: 'Starcall',
    targeting: 'ground_aoe',
    range: 800,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 265,
    cooldown: 8,
    manaCost: 45,
    vfxId: 'soraka_q',
    status: 'wired'
  },
  {
    id: 'soraka_w',
    champKey: 'soraka',
    slot: 'W',
    name: 'Astral Infusion',
    targeting: 'targeted',
    range: 550,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 6,
    manaCost: 40,
    vfxId: 'soraka_w',
    status: 'wired'
  },
  {
    id: 'soraka_e',
    champKey: 'soraka',
    slot: 'E',
    name: 'Equinox',
    targeting: 'ground_aoe',
    range: 925,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 260,
    cooldown: 20,
    manaCost: 70,
    vfxId: 'soraka_e',
    status: 'wired'
  },
  {
    id: 'soraka_r',
    champKey: 'soraka',
    slot: 'R',
    name: 'Wish',
    targeting: 'self_buff',
    range: 0,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 150,
    manaCost: 100,
    vfxId: 'soraka_r',
    status: 'wired'
  }
];
